import { addActiveLinkClass } from '../../utils';

window.addEventListener('DOMContentLoaded', () => {
  addActiveLinkClass('.nav__link');
});
